import { Injectable } from '@angular/core';

@Injectable()
export class UtilService {

  private possibleChars: string = 'abcdefghijkmnopqrstuvwxyz023456789';
  constructor() { }

  randString(length: number) {
    var text = '';
    for (var i = 0; i < length; i++) {
      text += this.possibleChars.charAt(Math.floor(Math.random() * this.possibleChars.length));
    }
    return text;
  }

  uniq(a: any[]) {
    var prims = {"boolean":{}, "number":{}, "string":{}}, objs = [];

    return a.filter(function(item) {
      var type = typeof item;
      if(type in prims) {
        return prims[type].hasOwnProperty(item) ? false : (prims[type][item] = true);
      }
      else {
        return objs.indexOf(item) >= 0 ? false : objs.push(item);
      }
    });
  }

  roundDecimal(n: number, places: number = 0) {
    return parseFloat((Math.round(n *100) / 100).toFixed(places));
  }
}



// WEBPACK FOOTER //
// ./client/app/services/util.service.ts